import React from 'react';
import { observer } from 'mobx-react';
import { Card, CardContent, CardHeader } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { useTranslation } from '@gamiphy/react-i18n';
import { WelcomeGiftStore, WelcomeGiftTypes } from '@gamiphy/loyalty-station-desktop/store/welcomeGift';
import { WelcomeReward } from '@gamiphy/loyalty-station-desktop/components/welcomeGift/reward';
import { AppWelcomeGiftStore } from '@gamiphy/loyalty-station-desktop/store/appWelcomeGift';

const useStyles = makeStyles(() => ({
  root: {
    textAlign: 'center',
  },
}));

const LockedCard: React.FC = observer(() => {
  const classes = useStyles();
  const { t } = useTranslation();

  const title = React.useMemo(() => {
    switch (WelcomeGiftStore.type) {
      case WelcomeGiftTypes.discount:
        if (AppWelcomeGiftStore.welcomeGift?.minPurchaseAmount) {
          return t('welcomeGift.discount.locked.titleWithMinOrderValue', {
            defaultValue: 'Unlock your welcome coupon When buying over {{minOrderValue,currency}}',
            minOrderValue: AppWelcomeGiftStore.welcomeGift?.minPurchaseAmount,
          });
        }
        return t('welcomeGift.discount.locked.title', { defaultValue: 'Unlock your welcome coupon' });
      case WelcomeGiftTypes.points:
        return t('welcomeGift.points.locked.title', { defaultValue: 'Unlock your welcome {{, gems}}' });
      default:
        return undefined;
    }
  }, [WelcomeGiftStore.type, AppWelcomeGiftStore.welcomeGift]);

  return (
    <Card className={classes.root}>
      <CardHeader title={title} sx={{ textAlign: 'left' }} />
      <CardContent>
        <WelcomeReward />
      </CardContent>
    </Card>
  );
});

export default LockedCard;
